import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerOblivion } from 'app/models/customer-oblivion.model';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { CustomerOblivionService } from 'app/services/customer/customer-oblivion.service';
import { ConfirmationService, MessageService } from 'primeng/primeng';

@Component({
  selector: 'app-customer-oblivion',
  templateUrl: './customer-oblivion.component.html',
  styleUrls: ['./customer-oblivion.component.css']
})
export class CustomerOblivionComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;

  public customerOblivionList: CustomerOblivion[];
  public showDialog: boolean;
  public customerJson: any;

  newDataAvailable: boolean = false;


  constructor(
    public customerOblivionService: CustomerOblivionService,
    private messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    //this.customerOblivionService.getCustomerOblivionList().subscribe(res => {
    //  this.customerOblivionList = res;
    //})
  }

  openDialog(customerOblivion: CustomerOblivion) {
    this.customerJson = customerOblivion.customerJson;
    if (this.customerJson != null) {
      this.showDialog = true;
    }
  }

  closeDialog() {
    this.customerJson = null;
    this.showDialog = false;
  }

  recoverCustomer(customerId: number) {
    this.confirmationService.confirm({
      header: this.translate.instant('customerOblivion.confirmRecoverCustomerHeader'),
      message: this.translate.instant('customerOblivion.confirmRecoverCustomerMessage'),
      acceptLabel: 'OK',
      accept: () =>
        this.customerOblivionService.recoverCustomer(customerId).subscribe(res => {
          this.newDataAvailable = true;
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
        }),
      rejectVisible: false    
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-oblivion/customer-oblivion.component.ts